import React, { Component } from 'react';
import axios from "axios";
import {NotificationManager} from 'react-notifications';

class AddressNew extends Component {

    constructor(props) {
        super(props);
        const initialAddress = props.initialAddress || {};
        this.state = {
            address_id: initialAddress.address_id || '',
            user_name: initialAddress.user_name || '',
            user_mobile: initialAddress.user_mobile || '',
            user_pincode: initialAddress.user_pincode || '',
            user_locality: initialAddress.user_locality || '',
            user_address: initialAddress.user_address || '',
            user_city: initialAddress.user_city || '',
            user_state: initialAddress.user_state || '',
            user_landmark: initialAddress.user_landmark || '',
            user_alternative_phone: initialAddress.user_alternative_phone || '',
            user_address_type: initialAddress.user_address_type || '',
            serviceCheck:false,
        }   
    }

    componentDidUpdate(prevProps) {
        if (prevProps.initialAddress !== this.props.initialAddress) {
            const initialAddress = this.props.initialAddress || {};
            this.setState({
                address_id: initialAddress.address_id || '',
                user_name: initialAddress.user_name || '',
                user_mobile: initialAddress.user_mobile || '',
                user_pincode: initialAddress.user_pincode || '',
                user_locality: initialAddress.user_locality || '',
                user_address: initialAddress.user_address || '',
                user_city: initialAddress.user_city || '',
                user_state: initialAddress.user_state || '',
                user_landmark: initialAddress.user_landmark || '',
                user_alternative_phone: initialAddress.user_alternative_phone || '',
                user_address_type: initialAddress.user_address_type || '',
            });
        }
    }

    async submitAddress(){

        const { address_id, user_name, user_mobile, user_pincode, user_locality, user_address, user_city, user_state, user_landmark, user_alternative_phone, user_address_type}  = this.state ;

        if(user_name.length < 3) {
            NotificationManager.error('Please enter the valid name');
        }else if(user_mobile.length !== 10) {
            NotificationManager.error('Please enter the valid mobile number');
        }else if(user_pincode.length < 6) {
            NotificationManager.error('Please enter the valid pincode');
        }else if(user_locality.length < 3) {
            NotificationManager.error('Please enter the locality');
        }else if(user_address.length < 5) {
            NotificationManager.error('Please enter the address');
        }else if(user_city.length < 3) {
            NotificationManager.error('Please enter the city');
        }else if(user_state.length < 3) {
            NotificationManager.error('Please enter the state');
        }else if(user_address_type==='') {
            NotificationManager.error('Please select address type');
        }else{

          const params = new URLSearchParams();
          params.append('token', localStorage.getItem('byos_token'));
          if (address_id) {
            params.append('address_id', address_id);
          }
          params.append('user_name', user_name);
          params.append('user_mobile', user_mobile);
          params.append('user_pincode', user_pincode);
          params.append('user_locality', user_locality);
          params.append('user_address', user_address);
          params.append('user_city', user_city);
          params.append('user_state', user_state);
          params.append('user_landmark', user_landmark);
          params.append('user_alternative_phone', user_alternative_phone);
          params.append('user_address_type', user_address_type);
            try {
                const response = await axios.post('https://shop.mybadge.co.in/api/apiv1/addressAdd',params);
                let resVal=response.data;
                if(resVal.status==='success'){
                    NotificationManager.success(resVal.message);
                    if (this.props.onSaved) {
                        this.props.onSaved();
                    }
                    this.props.showNewAddressBox(false);
                }else{
                    NotificationManager.error(resVal.message);
                }
            } catch (error) {
                console.error(error);
            }

        }
    }


    render() {
        const { address_id, user_name, user_mobile, user_pincode, user_locality, user_address, user_city, user_state, user_landmark, user_alternative_phone, user_address_type }  = this.state ;
        const isEditing = !!address_id;
        return (
            <div className="ps-address__form">
                    <div className="ps-address__formHeader">
                        <div>
                            <span className="ps-account-shell__panelLabel">Address form</span>
                            <h3>{isEditing ? 'Edit address' : 'Add new address'}</h3>
                        </div>
                        {isEditing ? <span className="ps-address__formBadge">Update mode</span> : null}
                    </div>

                    <div className="form-row">
                        <div className="ps-form__group col-md-6">
                        <label className="ps-form__label">Name</label>
                        <input type="text" className="form-control ps-form__input" name="user_name" value={user_name} onChange={(event)=>this.setState({'user_name':event.target.value})}/>
                        </div>
                        <div className="ps-form__group col-md-6">
                        <label className="ps-form__label">Mobile Number</label>
                        <input type="text" className="form-control ps-form__input" maxLength='10' name="user_mobile" value={user_mobile} onChange={(event)=>this.setState({'user_mobile':event.target.value})}/>
                        </div>
                    </div>

                    <div className="form-row">
                        <div className="ps-form__group col-md-6">
                        <label className="ps-form__label">Pincode</label>
                        <input type="text" className="form-control ps-form__input" maxLength='6' name="user_pincode" value={user_pincode} onChange={(event)=>this.setState({'user_pincode':event.target.value})}/>
                        </div>
                        <div className="ps-form__group col-md-6">
                        <label className="ps-form__label">Locality</label>
                        <input type="text" className="form-control ps-form__input" name="user_locality" value={user_locality} onChange={(event)=>this.setState({'user_locality':event.target.value})}/>
                        </div>
                    </div>

                    <div className="form-row">
                        <div className="ps-form__group col-md-12">
                        <label className="ps-form__label">Address (Area and Street)</label>
                        <textarea className="form-control ps-form__textarea" name="user_address" onChange={(event)=>this.setState({'user_address':event.target.value})}>{user_address}</textarea>
                        </div>
                    </div>

                    <div className="form-row">
                        <div className="ps-form__group col-md-6">
                        <label className="ps-form__label">City/District/Town</label>
                        <input type="text" className="form-control ps-form__input" name="user_city" value={user_city} onChange={(event)=>this.setState({'user_city':event.target.value})}/>
                        </div>
                        <div className="ps-form__group col-md-6">
                        <label className="ps-form__label">State</label>
                        <input type="text" className="form-control ps-form__input" name="user_state" value={user_state} onChange={(event)=>this.setState({'user_state':event.target.value})}/>
                        </div>
                    </div>

                    <div className="form-row">
                        <div className="ps-form__group col-md-6">
                        <label className="ps-form__label">Landmark(Optional)</label>
                        <input type="text" className="form-control ps-form__input" name="user_landmark" value={user_landmark} onChange={(event)=>this.setState({'user_landmark':event.target.value})}/>
                        </div>
                        <div className="ps-form__group col-md-6">
                        <label className="ps-form__label">Alternative Phone(Optional)</label>
                        <input type="text" className="form-control ps-form__input" name="user_alternative_phone" value={user_alternative_phone} onChange={(event)=>this.setState({'user_alternative_phone':event.target.value})}/>
                        </div>
                    </div>

                    <div className="form-row">
                        <div className="ps-form__group col-md-6">
                        <label className="ps-form__label">Address Type </label>
                            <br/>

                            <div className="form-check form-check-inline">
                            <input className="form-check-input" type="radio" name="user_address_type" id="inlineRadio1" value="H" onChange={(event)=>this.setState({'user_address_type':event.target.value})}/>
                            <label className="form-check-label" htmlFor="inlineRadio1">Home</label>
                            </div>
                            <div className="form-check form-check-inline">
                            <input className="form-check-input" type="radio" name="user_address_type" id="inlineRadio2" value="W" onChange={(event)=>this.setState({'user_address_type':event.target.value})}/>
                            <label className="form-check-label" htmlFor="inlineRadio2">Work</label>
                            </div>
                        </div>
                    </div>
                    
                    <div className="form-row">
                        <div className="ps-form__group col-md-6">
                            <br/>
                            <button type="button" className="ps-btn ps-btn--warning" onClick={()=>this.submitAddress()}>{isEditing ? 'Update address' : 'Save address'}</button>
                            <button type="button" className="ps-address__cancelButton" onClick={()=>this.props.showNewAddressBox(false)}>Cancel</button>
                        </div>
                    </div>
            </div>
        );
    }
}

export default AddressNew;
